import { faThumbsUp } from '@fortawesome/pro-solid-svg-icons';
import { ActionButton } from 'components';
import { SupplierPickupCard } from 'components/supplier-pickup';
import { TripContext } from 'contexts';
import notify from 'devextreme/ui/notify';
import React, { Fragment, useContext } from 'react';
import { useLoadManagerService, useNavigation, useParamService, useSettingService, useStopService, useTripService } from 'services';
import { StopStatus, TripStatus, FailedRequestType } from 'services/enums';
import { SyncingStatus } from 'services/enums/syncingStatus';
import { Order, Stop } from 'services/types';
import './supplier-pickup.scss';

export const SupplierPickup = () => {

    const { getIntValue, getStringValue } = useParamService
    const { updateStopStatus } = useStopService()
    const { updateTripStatus } = useTripService()
    const { navigateBack } = useNavigation()
    const { completeStop } = useLoadManagerService()
    const { getTrainingMode } = useSettingService()

    const isTrainingMode: boolean = getTrainingMode()

    const tripId: number | undefined = getIntValue('tripId')
    const stopId: number | undefined = getIntValue('stopId')
    const readOnly: boolean | undefined = getStringValue('readOnly') == 'true'

    const tripContext = useContext(TripContext)
    let pendingStops: Stop[] = tripContext.stops.filter(stop => stop.tripId == tripId && stop.stopStatus != StopStatus.Complete)
    const orders: Order[] = tripContext.orders.filter(o => o.stopId === stopId) ?? []

    const completePickup = (): void => {
        stopId && updateStopStatus(stopId, StopStatus.Complete)
        stopId && !isTrainingMode && completeStop(stopId)
        if (pendingStops.length > 1) {
            navigateBack('/load-appointments')
        }
        else if (pendingStops.length == 1) { // last stop for this trip
            updateTripStatus(tripId!, TripStatus.Complete)
            navigateBack('/load-assignments')
        }
        else { // this condition occurs only if the dexie is cleared for some reason
            notify(`Some error occured, please retry later`, 'info', 5000)
        }
    }

    return (
        <Fragment>
            <div style={{ paddingBottom: '30px' }}>
                <Fragment>
                    {orders.map(order => <SupplierPickupCard key={order.id} orderId={order.id}></SupplierPickupCard>)}
                </Fragment>
                {!readOnly &&
                    <div className={'bottom-fix-action-row'}>
                        <ActionButton
                            icon={faThumbsUp}
                            buttonColor={'#82BC24'}
                            buttonWidth='150px'
                            buttonText='Complete Stop'
                            onClick={completePickup}
                        />
                    </div>
                }
            </div>
        </Fragment>
    )
};
